<template>
  <slot ref="root" />
</template>

<script>
import { col as componentProps } from "./props";
</script>

<script setup>
import { ref } from "vue";
import { useCol } from "./composables/use-col";

defineProps(componentProps);

const root = ref(null);
useCol(root);
</script>

<style lang="scss">
@import "./styles/col";
</style>
